import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axios";
import { loadStatus } from "../util";

/**
 *
 * Account Types
 */
//Get All Account Types
export const getAccountTypes = createAsyncThunk(
  "accounts/getAccountTypes",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().accounts;
      if (state.count.getAccountTypes <= 1) {
        const res = await axios.get("/account-types");
        return res.data;
      }
      return { count: 0, data: [] };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);
//Get Single Account type by id
export const getAccountType = createAsyncThunk(
  "accounts/getAccountType",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.get("/account-type/" + reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);
//Add Single Account type
export const addAccountType = createAsyncThunk(
  "accounts/addAccountType",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-account-type/", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);
//Edit Account type by id
export const editAccountType = createAsyncThunk(
  "accounts/editAccountType",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put("/edit-account-type/" + id, data);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);
//Delete Account type
export const deleteAccountType = createAsyncThunk(
  "accounts/deleteAccountType",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.delete("/delete-account-type/" + reqData.id, {
        params: reqData.data,
      });
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

/**
 *
 * Account Categories
 */
//Get All Account Categories
export const getAccountCategories = createAsyncThunk(
  "accounts/getAccountCategories",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().accounts;
      if (state.count.getAccountCategories <= 1) {
        const res = await axios.get("/account-categories");
        return res.data;
      }
      return { count: 0, data: [] };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);
//Get Single Account type by id
export const getAccountCategory = createAsyncThunk(
  "accounts/getAccountCategory",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.get("/account-category/" + reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);
//Add Single Account type
export const addAccountCategory = createAsyncThunk(
  "accounts/addAccountCategory",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-account-category/", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);
//Edit Account type by id
export const editAccountCategory = createAsyncThunk(
  "accounts/editAccountCategory",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put("/edit-account-category/" + id, data);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);
//Delete Account type
export const deleteAccountCategory = createAsyncThunk(
  "accounts/deleteAccountCategory",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.delete("/delete-account-type/" + reqData, {
        params: reqData,
      });
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

/**
 *
 * Accounts
 */
//Get All Account
export const getAccounts = createAsyncThunk(
  "accounts/getAccounts",
  async (reqData, { rejectWithValue, getState }) => {
    try {
      const state = getState().accounts;
      if (state.count.getAccounts <= 1) {
        const res = await axios.get("/accounts");
        return res.data;
      }
      return { count: 0, data: state.data };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);
//Get All Account by Search Term
export const getAccountByTerm = createAsyncThunk(
  "accounts/getAccountByTerm",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.get("/search-accounts", {
        params: { term: reqData },
      });

      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

//Get All Expenditure Account by Search Term
export const getExpenditureAccountByTerm = createAsyncThunk(
  "accounts/getExpenditureAccountByTerm",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.get("/search-accounts", {
        params: { term: reqData },
      });
      return res.data.filter((item) => item.account_type === "Expenditure");
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

//Get All Expenditure Account by Search Term
export const getIncomeAccountByTerm = createAsyncThunk(
  "accounts/getIncomeAccountByTerm",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.get("/search-accounts", {
        params: { term: reqData },
      });
      return res.data.filter((item) => item.account_type === "Income");
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

//Get Single Account by id
export const getAccount = createAsyncThunk(
  "accounts/getAccount",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.get("/account/" + reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

//Add Single Account
export const addAccount = createAsyncThunk(
  "accounts/addAccount",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-account/", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

//Add Single Account
export const addProjectAccount = createAsyncThunk(
  "accounts/addProjectAccount",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.post("/add-project-account/", reqData);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

//Edit Account by id
export const editAccount = createAsyncThunk(
  "accounts/editAccount",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put("/edit-account/" + id, data);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

//Delete Account
export const deleteAccount = createAsyncThunk(
  "accounts/deleteAccount",
  async (reqData, { rejectWithValue }) => {
    try {
      const res = await axios.delete("/delete-account/" + reqData.id, {
        params: reqData.data,
      });
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error);
    }
  }
);

const accountsSlice = createSlice({
  name: "accounts",
  initialState: {
    total: 0,
    accountTypes: [],
    accountCategories: [],
    data: [],
    selected: {},
    selectedAccount: {},
    selectedAccountType: {},
    selectedAccountCategory: {},
    load: {
      getAccounts: false,
      getAccount: false,
      addAccount: false,
      editAccount: false,
      deleteAccount: false,
      getAccountByTerm: false,
      addProjectAccount: false,
      getIncomeAccountByTerm: false,
      getExpenditureAccountByTerm: false,

      getAccountTypes: false,
      getAccountType: false,
      addAccountType: false,
      editAccountType: false,
      deleteAccountType: false,
      getAccountTypeByTerm: false,

      getAccountCategories: false,
      getAccountCategory: false,
      addAccountCategory: false,
      editAccountCategory: false,
      deleteAccountCategory: false,
      getAccountCategoryByTerm: false,
    },
    count: {
      getAccounts: 0,
      getAccount: 0,
      addAccount: 0,
      editAccount: 0,
      deleteAccount: 0,
      getAccountByTerm: 0,
      addProjectAccount: 0,
      getIncomeAccountByTerm: 0,
      getExpenditureAccountByTerm: 0,

      getAccountTypes: 0,
      getAccountType: 0,
      addAccountType: 0,
      editAccountType: 0,
      deleteAccountType: 0,
      getAccountTypeByTerm: 0,

      getAccountCategories: 0,
      getAccountCategory: 0,
      addAccountCategory: 0,
      editAccountCategory: 0,
      deleteAccountCategory: 0,
      getAccountCategoryByTerm: 0,
    },
  },
  reducers: {
    setSelectedAccount: (state, action) => {
      state.selected = action.payload;
    },

    unsetSelectedAccount: (state) => {
      state.selected = {};
      state.selectedAccount = {};
      state.selectedAccountType = {};
      state.selectedAccountCategory = {};
    },

    unsetAccounts: (state) => {
      state.data = [];
    },
    unsetAccountTypes: (state) => {
      state.accountTypes = [];
      state.selectedAccountType = {};
    },
    unsetAccountCategories: (state) => {
      state.accountCategories = [];
      state.selectedAccountCategory = {};
    },
    unsetAllAccounts: (state) => {
      state.data = [];
      state.accountTypes = [];
      state.accountCategories = [];
      state.selected = {};
    },
  },
  extraReducers: (builder) => {
    builder
      //Get all Account Types
      .addCase(getAccountTypes.pending, (state) => {
        state.load.getAccountTypes = loadStatus.loading;
        state.error = null;
        state.count.getAccountTypes = ++state.count.getAccountTypes;
      })
      .addCase(getAccountTypes.fulfilled, (state, action) => {
        state.load.getAccountTypes = loadStatus.success;
        state.accountTypes = action.payload.data;
        state.total = action.payload.count;
        state.count.getAccountTypes = 0;
      })
      .addCase(getAccountTypes.rejected, (state, action) => {
        state.load.getAccountTypes = loadStatus.error;
        state.error = action.error;
        state.count.getAccountTypes = 0;
      })
      //Get Account Type
      .addCase(getAccountType.pending, (state) => {
        state.load.getAccountType = loadStatus.loading;
        state.error = null;
        state.count.getAccountType = ++state.count.getAccountType;
      })
      .addCase(getAccountType.fulfilled, (state, action) => {
        state.load.getAccountType = loadStatus.success;
        state.selectedAccountType = action.payload;
        state.count.getAccountType = 0;
      })
      .addCase(getAccountType.rejected, (state, action) => {
        state.load.getAccountType = loadStatus.error;
        state.error = action.error;
        state.count.getAccountType = 0;
      })
      //Add Account Type
      .addCase(addAccountType.pending, (state) => {
        state.load.addAccountType = loadStatus.loading;
        state.error = null;
        state.count.addAccountType = ++state.count.addAccountType;
      })
      .addCase(addAccountType.fulfilled, (state, action) => {
        state.load.addAccountType = loadStatus.success;
        state.accountTypes.unshift(action.payload);
        state.count.addAccountType = 0;
      })
      .addCase(addAccountType.rejected, (state, action) => {
        state.load.addAccountType = loadStatus.error;
        state.error = action.error;
        state.count.addAccountType = 0;
      })
      //Edit Account Type
      .addCase(editAccountType.pending, (state) => {
        state.load.editAccountType = loadStatus.loading;
        state.error = null;
        state.count.editAccountType = ++state.count.editAccountType;
      })
      .addCase(editAccountType.fulfilled, (state, action) => {
        state.load.editAccountType = loadStatus.success;
        const index = state.accountTypes.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.accountTypes[index] = action.payload;
        }
        state.count.editAccountType = 0;
      })
      .addCase(editAccountType.rejected, (state, action) => {
        state.load.editAccountType = loadStatus.error;
        state.error = action.error;
        state.count.editAccountType = 0;
      })
      //Delete Account Type
      .addCase(deleteAccountType.pending, (state) => {
        state.load.deleteAccountType = loadStatus.loading;
        state.error = null;
        state.count.deleteAccountType = ++state.count.deleteAccountType;
      })
      .addCase(deleteAccountType.fulfilled, (state, action) => {
        state.load.deleteAccountType = loadStatus.success;
        state.accountTypes.filter((item) => item.id !== action.meta.arg.id);
        state.count.deleteAccountType = 0;
      })
      .addCase(deleteAccountType.rejected, (state, action) => {
        state.load.deleteAccountType = loadStatus.error;
        state.error = action.error;
        state.count.deleteAccountType = 0;
      })
      /**
       *
       * Account Categories
       */

      //Get all Account Categories
      .addCase(getAccountCategories.pending, (state) => {
        state.load.getAccountCategories = loadStatus.loading;
        state.error = null;
        state.count.getAccountCategories = ++state.count.getAccountCategories;
      })
      .addCase(getAccountCategories.fulfilled, (state, action) => {
        state.load.getAccountCategories = loadStatus.success;
        state.accountCategories = action.payload.data;
        state.total = action.payload.count;
        state.count.getAccountCategories = 0;
      })
      .addCase(getAccountCategories.rejected, (state, action) => {
        state.load.getAccountCategories = loadStatus.error;
        state.error = action.error;
        state.count.getAccountCategories = 0;
      })
      //Get Account Category
      .addCase(getAccountCategory.pending, (state) => {
        state.load.getAccountCategory = loadStatus.loading;
        state.error = null;
        state.count.getAccountCategory = ++state.count.getAccountCategory;
      })
      .addCase(getAccountCategory.fulfilled, (state, action) => {
        state.load.getAccountCategory = loadStatus.success;
        state.selectedAccountCategory = action.payload;
        state.count.getAccountCategory = 0;
      })
      .addCase(getAccountCategory.rejected, (state, action) => {
        state.load.getAccountCategory = loadStatus.error;
        state.error = action.error;
        state.count.getAccountCategory = 0;
      })
      //Add Account Category
      .addCase(addAccountCategory.pending, (state) => {
        state.load.addAccountCategory = loadStatus.loading;
        state.error = null;
        state.count.addAccountCategory = ++state.count.addAccountCategory;
      })
      .addCase(addAccountCategory.fulfilled, (state, action) => {
        state.load.addAccountCategory = loadStatus.success;
        state.accountCategories.unshift(action.payload);
        state.count.addAccountCategory = 0;
      })
      .addCase(addAccountCategory.rejected, (state, action) => {
        state.load.addAccountCategory = loadStatus.error;
        state.error = action.error;
        state.count.addAccountCategory = 0;
      })
      //Edit Account Category
      .addCase(editAccountCategory.pending, (state) => {
        state.load.editAccountCategory = loadStatus.loading;
        state.error = null;
        state.count.editAccountCategory = ++state.count.editAccountCategory;
      })
      .addCase(editAccountCategory.fulfilled, (state, action) => {
        state.load.editAccountCategory = loadStatus.success;
        state.selectedAccountCategory = action.payload;
        const index = state.accountCategories.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.accountCategories[index] = action.payload;
        }
        state.count.editAccountCategory = 0;
      })
      .addCase(editAccountCategory.rejected, (state, action) => {
        state.load.editAccountCategory = loadStatus.error;
        state.error = action.error;
        state.count.editAccountCategory = 0;
      })

      /**
       *
       * Accounts
       */
      //Get all Account
      .addCase(getAccounts.pending, (state) => {
        state.load.getAccounts = loadStatus.loading;
        state.error = null;
        state.count.getAccounts = ++state.count.getAccounts;
      })
      .addCase(getAccounts.fulfilled, (state, action) => {
        state.load.getAccounts = loadStatus.success;
        state.data = action.payload.data;
        state.total = action.payload.count;
        state.total = action.payload.count;
        state.count.getAccounts = 0;
      })
      .addCase(getAccounts.rejected, (state, action) => {
        state.load.getAccounts = loadStatus.error;
        state.error = action.error;
        state.count.getAccounts = 0;
      })
      //Get Accounts by term
      .addCase(getAccountByTerm.pending, (state) => {
        state.load.getAccountByTerm = loadStatus.loading;
        state.error = null;
        state.count.getAccountByTerm = ++state.count.getAccountByTerm;
      })
      .addCase(getAccountByTerm.fulfilled, (state, action) => {
        state.load.getAccountByTerm = loadStatus.success;
        state.selectedAccount = action.payload;
        state.count.getAccountByTerm = 0;
      })
      .addCase(getAccountByTerm.rejected, (state, action) => {
        state.load.getAccountByTerm = loadStatus.error;
        state.error = action.error;
        state.count.getAccountByTerm = 0;
      })
      //Get Expenditure Accounts by term
      .addCase(getExpenditureAccountByTerm.pending, (state) => {
        state.load.getExpenditureAccountByTerm = loadStatus.loading;
        state.error = null;
        state.count.getExpenditureAccountByTerm = ++state.count
          .getExpenditureAccountByTerm;
      })
      .addCase(getExpenditureAccountByTerm.fulfilled, (state, action) => {
        state.load.getExpenditureAccountByTerm = loadStatus.success;
        state.selectedAccount = action.payload;
        state.count.getExpenditureAccountByTerm = 0;
      })
      .addCase(getExpenditureAccountByTerm.rejected, (state, action) => {
        state.load.getExpenditureAccountByTerm = loadStatus.error;
        state.error = action.error;
        state.count.getExpenditureAccountByTerm = 0;
      })
      //Get Income Accounts by term
      .addCase(getIncomeAccountByTerm.pending, (state) => {
        state.load.getIncomeAccountByTerm = loadStatus.loading;
        state.error = null;
        state.count.getIncomeAccountByTerm = ++state.count
          .getIncomeAccountByTerm;
      })
      .addCase(getIncomeAccountByTerm.fulfilled, (state, action) => {
        state.load.getIncomeAccountByTerm = loadStatus.success;
        state.selectedAccount = action.payload;
        state.count.getIncomeAccountByTerm = 0;
      })
      .addCase(getIncomeAccountByTerm.rejected, (state, action) => {
        state.load.getIncomeAccountByTerm = loadStatus.error;
        state.error = action.error;
        state.count.getIncomeAccountByTerm = 0;
      })
      //Get Account
      .addCase(getAccount.pending, (state) => {
        state.load.getAccount = loadStatus.loading;
        state.error = null;
        state.count.getAccount = ++state.count.getAccount;
      })
      .addCase(getAccount.fulfilled, (state, action) => {
        state.load.getAccount = loadStatus.success;
        state.selectedAccount = action.payload;
        state.count.getAccount = 0;
      })
      .addCase(getAccount.rejected, (state, action) => {
        state.load.getAccount = loadStatus.error;
        state.error = action.error;
        state.count.getAccount = 0;
      })
      //Add Account
      .addCase(addAccount.pending, (state) => {
        state.load.addAccount = loadStatus.loading;
        state.error = null;
        state.count.addAccount = ++state.count.addAccount;
      })
      .addCase(addAccount.fulfilled, (state, action) => {
        state.load.addAccount = loadStatus.success;
        state.data.unshift(action.payload);
        state.count.addAccount = 0;
      })
      .addCase(addAccount.rejected, (state, action) => {
        state.load.addAccount = loadStatus.error;
        state.error = action.error;
        state.count.addAccount = 0;
      })
      //Add Project Account
      .addCase(addProjectAccount.pending, (state) => {
        state.load.addProjectAccount = loadStatus.loading;
        state.error = null;
        state.count.addProjectAccount = ++state.count.addProjectAccount;
      })
      .addCase(addProjectAccount.fulfilled, (state, action) => {
        state.load.addProjectAccount = loadStatus.success;
        state.data.unshift(action.payload);
        state.count.addProjectAccount = 0;
      })
      .addCase(addProjectAccount.rejected, (state, action) => {
        state.load.addProjectAccount = loadStatus.error;
        state.error = action.error;
        state.count.addProjectAccount = 0;
      })
      //Edit Account
      .addCase(editAccount.pending, (state) => {
        state.load.editAccount = loadStatus.loading;
        state.error = null;
        state.count.editAccount = ++state.count.editAccount;
      })
      .addCase(editAccount.fulfilled, (state, action) => {
        state.load.editAccount = loadStatus.success;
        state.selectedAccount = action.payload;
        const index = state.data.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.accounts[index] = action.payload;
        }
        state.count.editAccount = 0;
      })
      .addCase(editAccount.rejected, (state, action) => {
        state.load.editAccount = loadStatus.error;
        state.error = action.error;
        state.count.editAccount = 0;
      })
      //Delete Account
      .addCase(deleteAccount.pending, (state) => {
        state.load.deleteAccount = loadStatus.loading;
        state.error = null;
        state.count.deleteAccount = ++state.count.deleteAccount;
      })
      .addCase(deleteAccount.fulfilled, (state, action) => {
        state.load.deleteAccount = loadStatus.success;
        state.data.filter((item) => item.id !== action.meta.arg.id);
        state.count.deleteAccount = 0;
      })
      .addCase(deleteAccount.rejected, (state, action) => {
        state.load.deleteAccount = loadStatus.error;
        state.error = action.error;
        state.count.deleteAccount = 0;
      });
  },
});

export const {
  setSelectedAccount,
  unsetAccounts,
  unsetSelectedAccount,
  unsetAccountCategories,
  unsetAccountTypes,
  unsetAllAccounts,
} = accountsSlice.actions;
export default accountsSlice.reducer;
